export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-10">联系我们</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <a href="#" className="group flex flex-col items-center text-center p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
              <i className="ri-mail-line text-2xl"></i>
            </div>
            <h3 className="text-base font-bold text-foreground-900 mb-2">商务合作</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">广告投放、品牌合作、资源互换，欢迎来函洽谈</p>
            <span className="text-xs text-primary-600 mt-3 font-medium whitespace-nowrap">bd@91yingshi.com</span>
          </a>

          <a href="#" className="group flex flex-col items-center text-center p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
              <i className="ri-feedback-line text-2xl"></i>
            </div>
            <h3 className="text-base font-bold text-foreground-900 mb-2">内容投稿</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">片源推荐、影评投稿、资源分享，期待你的加入</p>
            <span className="text-xs text-accent-600 mt-3 font-medium whitespace-nowrap">submit@91yingshi.com</span>
          </a>

          <a href="#" className="group flex flex-col items-center text-center p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-secondary-200 transition-all duration-300 cursor-pointer">
            <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-4 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all duration-300">
              <i className="ri-question-answer-line text-2xl"></i>
            </div>
            <h3 className="text-base font-bold text-foreground-900 mb-2">问题反馈</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">播放问题、功能建议，技术团队快速响应处理</p>
            <span className="text-xs text-secondary-600 mt-3 font-medium whitespace-nowrap">support@91yingshi.com</span>
          </a>
        </div>
      </div>
    </section>
  );
}